import React from 'react';

import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { PricingPlanChangeOptions } from 'src/features/stay/types';
import { ChangeActiveStayPricingPlanFormSchemaValues } from 'src/features/stay/utils/formSchema';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { Form } from 'src/registry/ui/Form';
import { translate } from 'src/utils/translate';

type Props = {
    form: UseFormReturn<ChangeActiveStayPricingPlanFormSchemaValues>;
    onSubmit: (values: ChangeActiveStayPricingPlanFormSchemaValues) => void;
    pricingPlanChangeOptions?: PricingPlanChangeOptions;
};
export default function ChangeActiveStayPricingPlanForm({ onSubmit, form, pricingPlanChangeOptions }: Props) {
    const { formatMessage, locale } = useIntl();

    const options = React.useMemo(() => {
        const permissionBasedOptions = pricingPlanChangeOptions?.permission_based_pricing_plans?.map((pricingPlan) => ({
            value: pricingPlan.identity,
            label: translate(pricingPlan.translations, locale)?.name || '',
        }));

        if (permissionBasedOptions && permissionBasedOptions.length > 0) return permissionBasedOptions;

        const validationTypeOptions = pricingPlanChangeOptions?.validation_types_with_pricing_plans?.map(
            (validationType) => ({
                value: validationType.id,
                label: translate(validationType?.pricing_plan?.translations ?? [], locale)?.name || '',
            }),
        );
        if (validationTypeOptions && validationTypeOptions.length > 0) return validationTypeOptions;
        return [];
    }, [locale, pricingPlanChangeOptions]);

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <SelectFormField
                form={form}
                label={formatMessage(visitorMessages.pricingPlan)}
                options={options}
                disabled={
                    pricingPlanChangeOptions?.permission_based_pricing_plans?.length === 1 ||
                    pricingPlanChangeOptions?.validation_types_with_pricing_plans?.length === 1
                }
                name={
                    pricingPlanChangeOptions?.permission_based_pricing_plans
                        ? 'pricing_plan_identity'
                        : 'validation_type'
                }
            />
        </Form>
    );
}
